package org.hs_soft.runmynesto.domain.model.home.closing_reports

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
enum class CashbookTableHeadersEnum(
    val title: String,
    val isNumeric: Boolean = false,
    val key: String
) {
    INCOME_EXPENSE(
        title = LanguageManager.getCurrentStrings().incomeAndExpanse,
        key = "description"
    ),
    AMOUNT(
        title = LanguageManager.getCurrentStrings().amount,
        isNumeric = true,
        key = "amount"
    );
}